import { css } from '@emotion/react'
import { CornerRadius, cssVar, ThemedColors } from '@opallabs/gem'

export const assetNodeViewWrapper = ({
  width,
  height,
  selected,
}: {
  width: number
  height: number
  selected: boolean
}) =>
  css({
    position: 'relative',
    blockSize: height,
    inlineSize: width,
    borderRadius: CornerRadius.Large,

    ...(selected && {
      '&::before': {
        content: '""',
        position: 'absolute',
        insetBlockStart: 0,
        insetInlineStart: 0,
        insetInlineEnd: 0,
        insetBlockEnd: 0,
        border: `2px solid ${cssVar(ThemedColors.StrokePrimary2)}`,
        borderRadius: CornerRadius.Large,
        pointerEvents: 'none',
        zIndex: 1,
      },
    }),
  })

export const assetBase = ({ readOnly }: { readOnly: boolean }) =>
  css({
    inlineSize: '100%',
    blockSize: '100%',
    cursor: readOnly ? 'default' : 'grab',
  })

export const asset = css({
  inlineSize: 'inherit',
  blockSize: 'inherit',
  borderRadius: CornerRadius.Large,
  cursor: 'inherit',

  img: {
    display: 'inline-block',
    inlineSize: 'inherit',
    blockSize: 'inherit',
    borderRadius: 'inherit',
    cursor: 'inherit',
  },
})

export const assetOverlay = css({
  '> div': {
    flexGrow: 0,
  },

  '.kuiper-icon-wrapper': {
    blockSize: 16,
    inlineSize: 16,
  },
})
